export function DownloadResume() {
    window.open('https://raw.githubusercontent.com/qawitherev/qawi-portfolio/master/public/AbdulQawi_Resume_Dec2023.pdf', '_blank')
}

